var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResistor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 128,
    viewBox: "0 0 53 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5009_42390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 102H50.7916V5.35417C45.9345 1.67992 29.722 1.51887 23.7487 2.64619C20.3457 3.28442 18.5717 7.10181 18.7528 10.2631C23.0367 11.0981 34.8567 11.7602 36.2565 16.5081C37.2219 19.7708 31.2063 35.3685 28.4368 36.7702C24.4365 38.7922 10.2151 39.6332 6.61296 37.0147C5.87082 36.4719 0.506882 23.1886 0.217264 21.4707C-1.84023 9.12981 11.277 13.6152 15.8807 10.3943C17.1055 9.54137 16.5444 1.60834 22.6445 0.469086C26.325 -0.216853 42.972 -0.103525 46.8577 0.504873C48.4808 0.761355 53 3.05775 53 4.26262V102Z",
    fill: "#4D2117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3247 108.856L14.47 107.416C-8.96585 106.514 2.40884 95.155 5.34133 81C13.6149 82.7925 21.7501 80.516 29.6805 81.6035C30.4211 87.2619 37.4603 96.4097 35.7261 101.781C33.7631 107.864 22.3884 105.761 18.5346 108.856V128H16.3307V108.856H16.3247Z",
    fill: "#4D2117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 50V66.7574C22.3732 67.4409 14.5191 69.174 7 66.7574V51.1168C14.7943 51.5073 22.3553 52.264 30 50Z",
    fill: "#E6BC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.988 71L30 77.2053C21.9766 77.6248 15.0413 78.7617 7 77.2053L7.01795 71.0068C14.2522 73.7136 22.5446 72.015 29.988 71.0068V71Z",
    fill: "#F1805E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 48V42.1656C14.8283 43.6306 22.447 44.1847 30 41L29.8384 46.6306C29.0484 46.8026 27.6719 47.9936 27.2709 47.9936H7V48Z",
    fill: "#F1805E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5009_42390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResistor);
export default __webpack_public_path__ + "static/media/resistor.375d1ceed8684a90305e6c28bc7c7a65.svg";
export { ForwardRef as ReactComponent };